import React, { Component } from "react";
import JobTable from "../../../components/customer_portal/home/JobTable";
import { Box, Button, Tabs, Tab, Chip, Tooltip } from "@mui/material";
import Store from "../../../containers/customer_portal/dashboard/HomePageStore";
import TablePaginationActions from "../../../components/customer_portal/home/TablePaginationActions";
import "@fontsource/lexend";
import withRouter from "../../../helpers/withRouter";
import SendProofModal from "../../../components/customer_portal/job/SendProofModal";
import AddIcon from "@mui/icons-material/Add";
import { isAuth } from "../../../helpers/cookies";

class HomePageContainer extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    openSendProof: false,
    selectedJobId: null,
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const stageId = params.get("stage_id");
    const processId = params.get("process_id");

    if (stageId) {
      this.props.setStageTab(Number(stageId));
    }

    if (processId) {
      this.props.setProcessTab(Number(processId));
      this.props.setProcessHasJobForm(Number(processId));
    }

    if (this.props.selected_company) {
      this.props.get_company_process(this.props.selected_company);
    }
    this.fetchJobs();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      selected_company,
      selected_process_tab,
      selected_stage_tab,
      searchFilters,
    } = this.props;

    if (
      prevProps.selected_company !== selected_company ||
      prevProps.selected_process_tab !== selected_process_tab ||
      prevProps.selected_stage_tab !== selected_stage_tab ||
      prevProps.searchFilters !== searchFilters
    ) {
      this.setState({ page: 0 }, () => this.fetchJobs());
    }
  }

  fetchJobs = () => {
    const {
      selected_company,
      selected_process_tab,
      selected_stage_tab,
      searchFilters,
      get_job_list,
    } = this.props;
    const { page, rowsPerPage } = this.state;

    const auth = isAuth();
    const params = {
      company_id: selected_company,
      process_id: selected_process_tab,
      stage_id: selected_stage_tab,
      user_id: auth?.user_id || auth?.id,
      skip: page * rowsPerPage,
      limit: rowsPerPage,
    };

    if (searchFilters?.length > 0) {
      params.qn = searchFilters.map((f) => f.value.trim());
      const columns = searchFilters.map((f) => f.key).filter(Boolean);
      if (columns.length > 0) {
        params.column = columns;
      }
    }

    get_job_list(params);
  };

  handlePageChange = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.fetchJobs();
    });
  };





  formatJobs = (jobs) => {
    const { search_columns } = this.props;

    if (!Array.isArray(jobs)) return [];

    return jobs.map((job) => {
      // 1. Handle submitted_file transformation
      let processedJob = { ...job };
      if (Array.isArray(job.submitted_file)) {
        processedJob = {
          ...processedJob,
          submitted_file: job.submitted_file.map((url) => {
            const filename = decodeURIComponent(url.split("/").pop());
            return { url, filename };
          }),
        };
      }

      // 2. Rename keys based on search_columns
      if (Array.isArray(search_columns) && search_columns.length > 0) {
        const newJob = {};
        const jobKeys = Object.keys(processedJob);

        search_columns.forEach((col) => {
          const label =
            typeof col === "string" ? col : col.label || col.key;
          if (processedJob.hasOwnProperty(label)) {
            newJob[label] = processedJob[label];
          }
        });

        jobKeys.forEach((k) => {
          const isConfigured = search_columns.some((col) => {
            const cLabel =
              typeof col === "string" ? col : col.label || col.key;
            return cLabel === k;
          });
          
          if (!isConfigured && k !== "ref_No" && !k.startsWith("_")) {
            newJob[k] = processedJob[k];
          }
          // Always pass through internal flags starting with "_"
          if (k.startsWith("_") || k === "is_elapsed") {
            newJob[k] = processedJob[k];
          }
        });

        return newJob;
      }

      if (search_columns && typeof search_columns === "object") {
        const newJob = {};
        Object.keys(processedJob).forEach((key) => {
          const label = search_columns[key];
          const newKey = label || key;
          newJob[newKey] = processedJob[key];
        });
        return newJob;
      }

      return processedJob;
    });
  };

  handleCreateJob = () => {
    const { selected_process_tab } = this.props;
    const url = selected_process_tab
      ? `/create-job?process_id=${selected_process_tab}`
      : "/create-job";
    this.props.navigate(url);
  };

  handleSendProof = async (jobId) => {
    const action = await this.props.get_job_detail({ job_id: jobId });
    if (action.payload && action.payload.data) {
      this.props.setJobData(action.payload.data.job_data);
    }
    await this.props.proof_log_table({ job_id: jobId });
    this.setState({ openSendProof: true, selectedJobId: jobId });
  };

  setOpenSendProof = (val) => {
    this.setState({ openSendProof: val });
  };

  render() {
    const { job_list, job_total, common_loading, job_detail } = this.props;
    const { rowsPerPage } = this.state;
    const totalCount = job_total || 0;
    const formattedJobs = this.formatJobs(job_list);
    const auth = isAuth();
    const currentUserRole = Number(auth?.role);
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          mt: "-5px",
        }}
      >
        {/* Top bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 0,
            mt: 0,
            px: 2,
            py: 1.5,
            gap: 2,
            backgroundColor: "#fff",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              fontSize: "20px",
              fontFamily: "'Inter Tight', sans-serif",
              color: "black",
              fontWeight: 600,
            }}
          >
            {(() => {
              const {
                company_process,
                selected_process_tab,
                selected_stage_tab,
              } = this.props;
              let stageName = "";

              if (
                selected_process_tab &&
                selected_stage_tab &&
                company_process?.length > 0
              ) {
                const process = company_process.find(
                  (p) => p.id === selected_process_tab
                );
                if (process) {
                  const stage = process.stage?.find(
                    (s) => s.id === selected_stage_tab
                  );
                  if (stage) stageName = stage.name;
                }
              }

              if (selected_stage_tab === "my_library")
                stageName = "My Library";
              return stageName ? `Jobs : ${stageName}` : `Jobs - ${totalCount}`;
            })()}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TablePaginationActions
              count={totalCount}
              page={this.state.page}
              rowsPerPage={rowsPerPage}
              onPageChange={this.handlePageChange}
            />

            {currentUserRole  === 7 && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={this.handleCreateJob}
                sx={{
                  backgroundColor: "#ff6100",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#e55600" },
                }}
              >
                Create New Job
              </Button>
            )}
          </Box>
        </Box>



        <JobTable
          data={formattedJobs}
          total={totalCount}
          loading={common_loading}
          rowsPerPage={rowsPerPage}
          page={this.state.page}
          onPageChange={this.handlePageChange}
          selected_process_tab={this.props.selected_process_tab}
          selected_stage_tab={this.props.selected_stage_tab}
          company_process={this.props.company_process}
          onSendProof={this.handleSendProof}
          columns={this.props.table_columns}
        />

        <SendProofModal
          job_id={this.state.selectedJobId}
          job_detail={job_detail}
          comp_file_list={job_detail?.comp_file_list || []}
          is_SendProof_modal_open={this.state.openSendProof}
          handleSendProofModal={this.setOpenSendProof}
        />


      </Box>
    );
  }
}

export default withRouter(Store(HomePageContainer));
